import { FiArchive, FiCheckCircle, FiEdit, FiEye, FiTrash2, FiRefreshCcw, FiUserCheck, FiUserX, FiXCircle } from "react-icons/fi"

import { TQuestion } from "../../../api/type"
import { isUnverifiedQuestion } from "../utils/questionMeta"

type QuestionActionDropdownProps = {
  question: TQuestion
  style: { top: number; left: number }
  onView: () => void
  onEdit: () => void
  onPublish: () => void
  onArchive: () => void
  onActivate: () => void
  onMoveToDraft: () => void
  onToggleLearnerPublish: () => void
  onVerify: () => void
  onReject: () => void
  onDelete: () => void
}

const QuestionActionDropdown = ({
  question,
  style,
  onView,
  onEdit,
  onPublish,
  onArchive,
  onActivate,
  onMoveToDraft,
  onToggleLearnerPublish,
  onVerify,
  onReject,
  onDelete,
}: QuestionActionDropdownProps) => (
  <div
    className="action_dropdown action_dropdown--fixed"
    style={style}
  >
    <h4 onClick={onView}>
      <span>
        <FiEye />
      </span>{" "}
      View details
    </h4>
    <h4 onClick={onEdit}>
      <span>
        <FiEdit />
      </span>{" "}
      Edit
    </h4>
    {isUnverifiedQuestion(question) && (
      <>
        <h4 onClick={onVerify}>
          <span>
            <FiCheckCircle />
          </span>{" "}
          Verify
        </h4>
        {question.verification_status !== "rejected" && (
          <h4 onClick={onReject}>
            <span>
              <FiXCircle />
            </span>{" "}
            Reject
          </h4>
        )}
      </>
    )}
    {question.question_status === "draft" && !isUnverifiedQuestion(question) && (
      <h4 onClick={onPublish}>
        <span>
          <FiCheckCircle />
        </span>{" "}
        Publish Question
      </h4>
    )}
    {question.question_status === "published" && (
      <h4 onClick={onMoveToDraft}>
        <span>
          <FiRefreshCcw />
        </span>{" "}
        Move to Draft
      </h4>
    )}
    {question.question_status !== "archived" && (
      <h4 onClick={onArchive}>
        <span>
          <FiArchive />
        </span>{" "}
        Archive
      </h4>
    )}
    {question.question_status === "archived" && (
      <h4 onClick={onActivate}>
        <span>
          <FiCheckCircle />
        </span>{" "}
        Unarchive
      </h4>
    )}
    {question.question_status === "published" &&
      !isUnverifiedQuestion(question) &&
      (question.published_to_learner ? (
        <h4 onClick={onToggleLearnerPublish}>
          <span>
            <FiUserX />
          </span>{" "}
          Remove from learners
        </h4>
      ) : (
        <h4 onClick={onToggleLearnerPublish}>
          <span>
            <FiUserCheck />
          </span>{" "}
          Publish to learners
        </h4>
      ))}
    <h4 onClick={onDelete}>
      <span>
        <FiTrash2 />
      </span>{" "}
      Delete
    </h4>
  </div>
)

export default QuestionActionDropdown
